import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'

@Directive({
  selector: '[icos-class]',
})
export class IcosClassDirective implements OnInit {

  @Input('icos-class') classNames: string = ''


  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
  }

  ngOnInit(): void {
    this.renderer.addClass(this.el.nativeElement, this.classNames)
  }

}
